import { BaseService } from '../../infra/base.service'
import type { AppointmentResource } from '../appointments/appointment-resource'
import type { ResourceLock } from './resource-lock'
import type { ResourcesLockRepository } from './resources-lock.repository'

export class ResourcesLockService extends BaseService<ResourceLock> {
    constructor(private rep: ResourcesLockRepository) {
        super(rep)
    }

    async resourcesLocked(from: Date, to: Date): Promise<AppointmentResource[]> {
        return await this.rep.resourcesLocked(from, to)
    }

    // ids das salas/equipamentos em uso por OUTRO agendamento no intervalo (o próprio appointmentId é ignorado).
    // intervalo inválido ou vazio (ex: horário sendo digitado) não consulta nada.
    async lockedIds(start: Date, end: Date, appointmentId: string = null): Promise<string[]> {
        if (!start || !end) return []
        const from = new Date(start)
        const to = new Date(end)
        if (isNaN(from.getTime()) || isNaN(to.getTime()) || from.getTime() >= to.getTime()) return []
        const locked: AppointmentResource[] = await this.rep.resourcesLocked(from, to)
        return [...new Set(locked.filter((el) => !appointmentId || el.appointmentId !== appointmentId).map((el) => el.resourcesLockId))]
    }
}
